module.exports = __webpack_public_path__ + "static/motherChild-detail-aeb2731598afaaefa452b6f76b5b298b.jpg";